import { createStore } from "vuex";
import { auth } from "./auth";
import { files } from "./files";
import { todo } from "./todo";
import { view } from "./view";
import createPersistedState from "vuex-persistedstate";

const store = createStore({
    modules: {
        auth,
        files,
        todo,
        view,
    },
    plugins: [
        createPersistedState({
            paths: ["auth", "files", "todo", "view"],
        })
    ],
});

export default store;